module.exports = __webpack_public_path__ + "img/historial_gris.92e68f13.svg";